import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  IconButton,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  FaBullseye,
  FaUsers,
  FaBoxes,
  FaMoneyBillWave,
} from "react-icons/fa";
import { motion } from "framer-motion";
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';

const StoreReportsScreen = () => {
  const navigate = useNavigate();

  const steps = [
    {
      label: "Purchase Reports",
      path: "/PurchaseReports",
      color: "#9575CD",
      step: "01",
      icon: <LocalOfferIcon size={26} />,
    },
    {
      label: "Sold Items Reports",
      path: "/SoldItemsReports",
      color: "#FF8A65",
      step: "02",
      icon: <AccountBalanceWalletIcon size={26} />,
    },
    {
      label: "Stock Materia Reports",
      path: "/StockItemsMaterialReports",
      color: "#81C784",
      step: "03",
      icon: <FaBoxes size={26} />,
    },
    {
      label: "Store Expenses Reports",
      path: "/StoreExpensesReports",
      color: "#64B5F6",
      step: "04",
      icon: <FaMoneyBillWave size={26} />,
    },
  ];

  // Animation variants for framer-motion
  const cardVariant = {
    hidden: { opacity: 0, y: 50 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2,
        duration: 0.6,
        type: "spring",
        stiffness: 80,
      },
    }),
  };

  return (
    <Box sx={{ mt: "5%", mr: "1%", ml: "1%" }}>
      {/* Header */}
      <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} sx={{ color: "black", mr: 1 }}>
          <ArrowBackIcon />
        </IconButton>
        <Typography variant="h4" fontWeight="bold">
          Store Reports
        </Typography>
      </Box>

      {/* Main Card */}
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          minHeight: "500px",
          padding: "20px",
           width: "95%",
          mx: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
       <CardContent
        sx={{
          width: "100%",
          padding: 0,
        }}
        >
  <Box
    sx={{
      display: "flex",
      flexWrap: "nowrap", // keep in one row
      overflowX: "auto", // scroll horizontally if needed
      gap: 1.5,
      padding: 1.5,
    }}
  >
    {steps.map((item, idx) => (
      <motion.div
        key={idx}
        custom={idx}
        variants={cardVariant}
        initial="hidden"
        animate="visible"
        style={{ perspective: "1000px", minWidth: "240px" }} // lock width for scroll
      >
        <Box
  onClick={() => navigate(item.path)}
  sx={{
    position: "relative",
    width: 180, // matched width
    padding: "12px 10px", // matched padding
    minHeight: "230px", // matched height
    borderRadius: "14px", // matched border radius
    backgroundColor: "#f4f5f7",
     boxShadow: `
                      4px 4px 12px rgba(0, 0, 0, 0.2),     /* right + bottom */
                      0 4px 6px rgba(0, 0, 0, 0.1)          /* soft shadow */
                    `,
    cursor: "pointer",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
    textAlign: "center",
    "&:hover": {
      transform: "translateY(-4px) rotateY(3deg) rotateX(1.5deg)",
       boxShadow: `
                        6px 8px 24px rgba(0, 0, 0, 0.25),    /* enhanced right + bottom */
                        0 4px 16px rgba(0, 0, 0, 0.12)
                      `,
    },
  }}
>
  {/* Side Accent */}
  <Box
                            sx={{
                              position: "absolute",
                              top: 0,
                              bottom: 0,
                              left: -8, // <-- changed from right
                              width: "8px",
                              borderTopLeftRadius: "12px",
                              borderBottomLeftRadius: "12px",
                              backgroundColor: item.color,
                            }}
                          />

  {/* Icon */}
                                             <Box sx={{ mb: 2, color: item.color }}>{item.icon}</Box>
                                   
                                             {/* Label */}
                                             <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                                               {item.label}
                                             </Typography>
                                   
                                             {/* Description */}
                                             <Typography
                                               variant="body2"
                                               sx={{ color: "#666", mb: 2, minHeight: "40px" }}
                                             >
                                               Click to view report
                                             </Typography>
                                   
                                             {/* Number Circle */}
                                             <Box
                                               sx={{
                                                 width: 36,
                                                 height: 36,
                                                 borderRadius: "50%",
                                                 backgroundColor: item.color,
                                                 color: "#fff",
                                                 display: "flex",
                                                 alignItems: "center",
                                                 justifyContent: "center",
                                                 fontWeight: "bold",
                                                 fontSize: 14,
                                                 mx: "auto",
                                               }}
                                             >
                                               {item.step}
                                             </Box>
</Box>

      </motion.div>
    ))}
  </Box>
</CardContent>

      </Card>
    </Box>
  );
};

export default StoreReportsScreen;